import("babel-polyfill");
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/css/style.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import SlideVerify from './components/lib/index';
// import cnzzAnalytics from 'vue-cnzz-analytics'
// 引入公共js
import common from "./common/common.js";
Vue.prototype.common = common;
// api
import api from "./api";

Vue.config.productionTip = false;
Vue.prototype.$api = api;

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.use(SlideVerify);
// cnzz
/* api.common().then((res) => {
	if(res.data.help.copyright.statistics_url){
		Vue.use(cnzzAnalytics, {
		  router: router,
		  siteIdList: [
		    1279666948
		  ],
		  isDebug: false
		});
	}
}).catch((err) => {
	console.log(err)
}); */

router.afterEach((to, from, next) => {
	window.scrollTo(0, 0);
	/* if(router.currentRoute.name != 'signin' && router.currentRoute.name != 'register'){
		if (store.state.user) {
			if (store.state.user.token == "") {
				ElementUI.Message({
					showClose: true,
					message: "请先登录",
					type: "warning",
					offset: 200,
					duration: 1000,
				});
				setTimeout(()=>{
					router.push({
						name: "signin",
						query: {
							redirect: router.currentRoute.fullPath,
						},
					});
				},500)
			}
		} else {
			ElementUI.Message({
				showClose: true,
				message: "请先登录",
				type: "warning",
				offset: 200,
				duration: 1000,
			});
			setTimeout(()=>{
				router.push({
					name: "signin",
					query: {
						redirect: router.currentRoute.fullPath,
					},
				});
			},500)
		}
	} */
})
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
